import { Selector } from '@ngxs/store';
import { SelectedMatterDocumentsState } from '@state/global/documents/selected-matter-documents.state';
import { MatterDocumentSelectors } from '@state/matter/documents/documents.selectors';

export enum SelectedDocumentState {
	INITIALIZING = 'initializing',
	UPDATING = 'updating',
	READY = 'ready',
}

export class DocumentsMatterViewerSelector {
	@Selector([
		SelectedMatterDocumentsState.getLoading,
		SelectedMatterDocumentsState.convertingDocument,
		MatterDocumentSelectors.getLoading,
	])
	static documentStatus(
		initializing: boolean,
		converting: boolean,
		loadingMatterDocuments: boolean,
	): SelectedDocumentState {
		if (initializing || loadingMatterDocuments) {
			return SelectedDocumentState.INITIALIZING;
		}

		if (converting) {
			return SelectedDocumentState.UPDATING;
		}

		return SelectedDocumentState.READY;
	}
}
